module.exports = __webpack_public_path__ + "static/media/carouseltwo.d37532f0.svg";